import { Alert, CircularProgress, Modal, Snackbar, Box, FormControl, InputLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import { style as modalStyle } from "../../../components/Loading/Loading";
import { ErrorHandling } from "../../../components/Errors/Errors";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../state/slices/userSlice";
import { WhiteInput } from "../../../components/Inputs/InputText";
import stylesArquivarSolic from "./ArquivarSolicVistoria.module.css";
import servSolicitacaoVistoria from "../../../services/login/servSolicitacaoVistoria";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

const ArquivarSolicitacao = ({ setOpenPopup, recordForEdit, pesquisar, solicitacaoAcesso }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [openErrorWindow, setOpenErrorWindow] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [mensagemArquivamento, setMensagemArquivamento] = useState("");
    const [avisoOrcamentoConexaoAprovado, setAvisoOrcamentoConexaoAprovado] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
       if(solicitacaoAcesso.Content.Situacao === 4) {
        setAvisoOrcamentoConexaoAprovado(true);
       }

    }, [solicitacaoAcesso]);

    const handleCloseError = (event, reason) => {
        if (reason  === 'clickaway') {
            setOpenErrorWindow(false);
        }

        setOpenErrorWindow(false);
    }

    const solicitarArquivamento = async () => {
        if (recordForEdit === null) {
            return;
        }

        try {
            setIsLoading(true);

            if(mensagemArquivamento.trim() === '') {
                setOpenErrorWindow(true);
                setErrorMessage("O motivo do arquivamento deve ser preenchido.");
                setIsLoading(false);
                return;
            }

            if(mensagemArquivamento.length < 15) {
                setOpenErrorWindow(true);
                setErrorMessage("O motivo do arquivamento deve conter no mínimo 15 caracteres.");
                setIsLoading(false);
                return;
            }

            if(mensagemArquivamento.length > 4000) {
                setOpenErrorWindow(true);
                setErrorMessage("O motivo do arquivamento deve conter no máximo 4000 caracteres.");
                setIsLoading(false);
                return;
            }

            let id = recordForEdit?.row?.Id || recordForEdit?.Id;
    
            let dto = {
                CodigoSolicitacaoVistoria: id,
                Descricao: mensagemArquivamento,
                TipoUsuarioP3: 1
            }

            await servSolicitacaoVistoria.ArquivarSolicitacaoVistoria(dto);
            
            setIsLoading(false);

            setOpenPopup(false);

            pesquisar();

        } catch (err) {
            setIsLoading(false);

            return ErrorHandling(
                err?.request.status, 
                err?.message, 
                setOpenErrorWindow, 
                setErrorMessage, 
                dispatch, 
                logout, 
                navigate,
                err?.response?.data?.Message
            );
        }
        
    }

    return (
        <div style={{ width: "100%", height: "20%" }}>
            <h4>
                Você deseja arquivar a solicitação de vistoria? <br />
                Após o arquivamento, a solicitação só poderá ser acessada para visualização e não estará disponível para uso.
            </h4>
            <div>
                <FormControl variant="outlined" style={{ margin: '20px 0px 20px 35px', width: '90%' }}>
                    <InputLabel htmlFor="solicitacao-motivo-arquivamento" shrink style={{ color: "#B8B8B8" }}>
                        Motivo do arquivamento {avisoOrcamentoConexaoAprovado && <span className={stylesArquivarSolic.mesagemOrcamentoAprovado}>
                                {<FontAwesomeIcon style={{ width: '25px', height: '25px', color: 'yellow' }} icon={faTriangleExclamation} />} Orçamento de conexão já está aprovado</span>}
                    </InputLabel>
                    <WhiteInput 
                        fullWidth 
                        multiline
                        minRows={4}
                        placeholder="Insira um motivo"
                        type="text"
                        id="solicitacao-motivo-arquivamento"
                        onChange={(e) => setMensagemArquivamento(e.target.value)}
                    />
                </FormControl>
            </div>
            <div className={stylesArquivarSolic.homologacaoBotoes}>
                <BlueHoverButton onClick={solicitarArquivamento}>Arquivar</BlueHoverButton>
            </div>

            <Snackbar open={openErrorWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseError}> 
                    <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
                        {errorMessage}
                    </Alert>
            </Snackbar>

            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
        </div>
    )
}

export { ArquivarSolicitacao };